import { useEffect } from 'react';

/**
 * Reload page if restored from bfcache
 *
 * more info: https://web.dev/articles/bfcache
 */
export const useBfcacheReload = () => {
  useEffect(() => {
    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        window.location.reload();
      }
    };

    window.addEventListener('pageshow', handlePageShow);

    return () => window.removeEventListener('pageshow', handlePageShow);
  }, []);
};
